module.exports = __webpack_public_path__ + "static/logo-938005f25781667c3d7b481400ab7b6d.png";